<template>
  <BaseView class="index-container">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <div class="nav-panel">
          <HeaderView :active-index="4"/>
          <img src="../assets/spsc/capabilities/navBg.png" class="navImg"/>
        </div>
        <section class="nav-section">
          <div class="nav-info">
            <div class="nav-main-text" @click="goGoalPage('/')">Home</div>
            <div class="nav-arrow">></div>
            <div class="nav-sub-text" @click="goGoalPage('/capabilities')">Capabilities</div>
          </div>
          <div class="nav-line"></div>
        </section>
        <section class="content-panel">
          <div class="capability-content">
            <div class="text-title">SPSC has built good relationship with over 50 manufactories in China, SPSC has a wide range of capabilities ectending over most areas of infrastructure, marine and </div>
            <div class="text-title">chemical industries. About the project management , SPSC have several experienced project manager; About the project quality control, SPSC have rich experienced </div>
            <div class="text-title">QA&QC that have CWI, CSWIP and Nace certificates.</div>
          </div>
          <div class="map-info"></div>
          <div class="work-pic">
            <div class="work-pic1"></div>
            <div class="work-pic2"></div>
            <div class="work-pic3"></div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView
  },
  data () {
    return {

    }
  },
  methods: {
    goGoalPage( pathName) {
      this.$router.replace({ path: pathName})
    }
  },
  created () {
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}
.index-panel {
  width: 100%;
  min-width: 1200px;
} 

.nav-panel {
  width: 100%;

  height: 100%;
}

.navImg {
  width: 100%;
  height: auto;
  margin-top: -80px;
}

.nav-section {
  width: 1200px;
  margin: 40px auto 60px auto;
}

.nav-info {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
}

.nav-main-text, .nav-sub-text {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.nav-arrow {
  margin: 0 10px;
}

.nav-line {
  width: 100%;
  height: 1px;
  background: #D8D8D8;
  margin-top: 16px;
}

.content-panel {
  width: 1200px;
  margin: 0 auto 100px auto;
}

.text-title {
  font-size: 16px;
  color: #333333;
  line-height: 28px;
}

.map-info {
  width: 1133px;
  height: 714px;
  background: url('../assets/spsc/capabilities/map-info.png') no-repeat;
  background-size: contain;
  margin-top: 60px;
  margin-bottom: 80px;
}

.work-pic {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.work-pic1 {
  width: 380px;
  height: 260px;
  background: url('../assets/spsc/capabilities/work-pic1.png') no-repeat;
  background-size: contain;
}

.work-pic2 {
  width: 380px;
  height: 260px;
  background: url('../assets/spsc/capabilities/work-pic2.png') no-repeat;
  background-size: contain;
}

.work-pic3 {
  width: 380px;
  height: 260px;
  background: url('../assets/spsc/capabilities/work-pic3.png') no-repeat;
  background-size: contain;
}
</style>